import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { UiKitModule } from '@serviceplan/ui-kit';
import { ClientCoreModule, MatComponentsModule, ResizeService } from '@thehubz/client/core';
import { AssetTypeToIconNamePipe } from '../../pipes/asset-type-to-icon-name/asset-type-to-icon-name.pipe';
import { ProductBrandSelectionService } from '../../services/product-brand-selection.service';
import { AssetBulkEditComponent } from '../asset-bulk-edit/asset-bulk-edit.component';
import { AssetGalleryViewComponent } from '../asset-gallery-view/asset-gallery-view.component';
import { AssetListViewComponent } from '../asset-listview/asset-listview.component';
import { AssetProgressBarComponent } from '../asset-progress-bar/asset-progress-bar.component';
import { AssetsSidebarComponent } from '../assets/assets-sidebar/assets-sidebar.component';
import { AssetViewActionsComponent } from './collection-asset-view/asset-view-actions/asset-view-actions.component';
import { CollectionAssetListViewComponent } from './collection-asset-view/collection-asset-view.component';
import { CollectionAssetViewModule } from './collection-asset-view/collection-asset-view.module';
import { CustomClientMetadataComponent } from './collection-asset-view/custom-client-metadata/custom-client-metadata.component';
import { GeneralInfoComponent } from './collection-asset-view/general-info/general-info.component';
import { ThumbnailListComponent } from './collection-asset-view/thumbnail-list/thumbnail-list.component';
import { CollectionDashboardViewComponent } from './collection-dashboard-view/collection-dashboard-view.component';
import { CollectionPublishingComponent } from './collection-publishing/collection-publishing.component';
import { CollectionComponent } from './collection.component';
import { CollectionCardViewActionsComponent } from './collections-list/collection-card-view/collection-card-view-actions/collection-card-view-actions.component';
import { CollectionCardViewComponent } from './collections-list/collection-card-view/collection-card-view.component';
import { CollectionActionMenuComponent } from './collections-list/collection-list-view/collection-action-menu/collection-action-menu.component';
import { CollectionListViewComponent } from './collections-list/collection-list-view/collection-list-view.component';
import { CollectionsListActionsComponent } from './collections-list/collections-list-actions/collections-list-actions.component';
import { CollectionsListComponent } from './collections-list/collections-list.component';
import { CollectionsRoutingModule } from './collections-routing.module';
import { CollectionSelectViewComponent } from './components/select-collection-popup/collection-select-view/collection-select-view.component';
import { SelectCollectionPopupComponent } from './components/select-collection-popup/select-collection-popup.component';
import { CollectionAssetPreviewService } from './services/collection-asset-preview.service';
import { CollectionEventsService } from './services/collection-events.service';
import { CollectionSelectionService } from './services/collection-selection.service';
import { SelectCollectionDialogService } from './services/select-collection-dialog.service';

@NgModule({
  declarations: [
    CollectionComponent,
    CollectionAssetListViewComponent,
    CollectionsListComponent,
    AssetViewActionsComponent,
    ThumbnailListComponent,
    GeneralInfoComponent,
    CollectionPublishingComponent,
    SelectCollectionPopupComponent,
    CollectionDashboardViewComponent,
    CollectionSelectViewComponent,
    CustomClientMetadataComponent,
    CollectionCardViewComponent,
    CollectionsListActionsComponent,
    CollectionListViewComponent,
    CollectionCardViewActionsComponent,
    CollectionActionMenuComponent,
  ],
  imports: [
    CommonModule,
    CollectionsRoutingModule,
    FontAwesomeModule,
    UiKitModule,
    FormsModule,
    ClientCoreModule,
    ReactiveFormsModule,
    MatComponentsModule,
    CollectionAssetViewModule,
    AssetBulkEditComponent,
    AssetGalleryViewComponent,
    AssetListViewComponent,
    AssetProgressBarComponent,
    AssetsSidebarComponent,
    AssetTypeToIconNamePipe,
  ],
  providers: [
    ResizeService,
    ProductBrandSelectionService,
    CollectionSelectionService,
    CollectionEventsService,
    CollectionAssetPreviewService,
    SelectCollectionDialogService,
  ],
  exports: [CollectionsListComponent, CollectionDashboardViewComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CollectionsModule {}
